import request from "@utils/request";

export function getCopyTradeData(query) {
    return request({
        url: 'copy-trade/data',
        method: 'post',
        data: query
    })
}